import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "../config/axiosInstance";
import { NINJACURATE_BACKEND_BASE_URL } from "../config/api_config";

export const fetchPopularSkills = createAsyncThunk(
    'fetchPopularSkills/searchPopularSkills',
    async ({ searchValue }) => {
        const response = await axiosNoAuth.post(`${NINJACURATE_BACKEND_BASE_URL}/fast_search`,
            {
                skill: searchValue
            })

        return response.data

    }
)

const searchPopularSkillSlice = createSlice({
    name: 'searchPopularSkill',
    initialState: [],
    reducers: {
        selectSearchResult: (state, action) => {
            return [action.payload]
        }
    },
    extraReducers: (builder)=> {
        builder
        .addCase(fetchPopularSkills.fulfilled, (state, action) => {
            return action.payload
        })
    }
})

export const selectSearchResult = state => state.searchPopularSkill 
export default searchPopularSkillSlice.reducer
